import Vue from 'vue'
import Router from 'vue-router'
import xtgl from './xtgl'
import ywgl from './ywgl'
import kfgl from './kfgl'
import basic from './basic'
import cggl from './cggl'
import kcgl from './kcgl'
import cwgl from "./cwgl"
import jjgl from "./jjgl"
import bbzx from "./bbzx"
import printView from './printView'
import archives from './archives'
const Main = () => import ('../views/main/main.vue')
const dashboard = () => import ('../views/main/dashboard')

// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

Vue.use(Router)

const originalPush = Router.prototype.push

const basicRouter = {
  path: '/',
  component: Main,
  redirect: 'dashboard',
  children: [ {
    path: 'dashboard',
    component: dashboard,
    name: 'dashboard',
    meta: { title: '首页', keepAlive: true }
  },]
}

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export let routes = new Set([basicRouter,...xtgl, ...kfgl, ...ywgl, ...basic, ...cggl, ...kcgl, ...cwgl, ...jjgl, ...bbzx, ...printView, ...archives])
const router = new Router({
  routes
})
router.afterEach(to => {
  const app = router.app
  //const { name, params, query } = to
  to.matched[0].name !== '"archives"' && app.$store && (to.name && app.$store.commit('open_new_tabs', to))
})

export default router
